<template>
  <div id="CardItemsContainer" v-if="isSecurityShown(item)">
      <b-row class="m-1 p-3 ">
        <div class="toggleItem" v-b-toggle="'collapse-' + this.uid">
          <div class="titleAndIconContainer">
            <div class="title">{{item.security.name}}</div>
            <div class="toggleIconContainer">
              <span class="when-opened">
                <b-icon class="toggleArrow" icon="chevron-up" font-scale="3" />
              </span>
              <span class="when-closed">
                <b-icon class="toggleArrow" icon="chevron-down" font-scale="3" />
              </span>
            </div>
          </div>
          <transition name="fade">
            <div v-if="collapsed" class="mt-4 mb-4">
              <div class="subtitle">
                Vous pouvez économiser jusqu'à
                <span class="number">{{total_savings(item.saving_max)}}</span> de frais sur 25 ans
              </div>
            </div>
          </transition>
          <div class="toggleContentContainer">
            <div class="toggleContent">
              <p>Secteur : {{item.security.sector.name_french}}</p>
              <p>Europe ISIN : {{item.security.isin}}</p>
              <p>Vous possédez actuellement <span>{{Math.round(item.amount)}} €</span></p>
            </div>
            <transition name="fade">
              <div v-if="collapsed" style="display: flex">
                <div style="border-left: 4px solid #121212; margin: 10px" />
                <div class="frais">
                  <p>Frais de gestion : {{ Number(item.security.management_fees).toFixed(2) }} %</p>
                  <p>Frais d'entrée : {{ Number(item.security.entry_fees).toFixed(2) }} %</p>
                </div>
              </div>
            </transition>
            <div class="partNb">{{Math.round(item.number_shares)}} parts</div>
          </div>
        </div>
        <!-- expand CONTENT -->
        <b-collapse :id="'collapse-' + this.uid" class="collapseContainer mt-1">
          <b-row>
            <b-tabs content-class="mt-3" align="center" no-fade class="p-2">
              <b-tab v-if="item.alternatives.length > 0" title="Frais moins élevés" active>
                <b-col class="collapseBg">
                  <div id="CardItemsContainer">
                    <div v-for="(o, alt_esg) in item.alternatives" :key="alt_esg" class="mt-5">
                        <CardContent :title="o.name" :isin="o.isin" :secteur="o.sector.name_french" />
                        <b-row>
                          <b-col cols="6" style="color: white">
                            <card-collapse title="Frais moins élevés" :fees="o.management_fees"/>
                          </b-col>
                          <b-col cols="6">
                            <card-collapse title="Comparaison avec votre titre actuel" :fees="item.security.management_fees" />
                          </b-col>
                        </b-row>
                        <b-button class="right"  v-on:click="addAlternative(item,o)">Valider mon nouveau titre</b-button>
                    </div>
                  </div>
               <!--    <b-row>
                    <CardSelectTitre />
                  </b-row> -->
                </b-col>
              </b-tab>
              <b-tab v-else title="Frais moins élevés">
                <b-col class="collapseBg">
                  <CardContentEmpty title="Pas d'alternatives de frais" />
                </b-col>
              </b-tab>
              <b-tab v-if="item.alternatives_ESG.length > 0" title="Investissements plus verts">
                <div class="collapseBg">
                  <div id="CardItemsContainer">
                      <div v-for="(o, alt_esg) in item.alternatives_ESG" :key="alt_esg" class="mt-5">
                        <CardContent :title="o.name" :isin="o.isin" :secteur="o.sector.name_french" />
                        <b-row>
                          <b-col cols="6" style="color: white">
                            <CardContentEsg title="Investissements plus verts" :esg_score="o.esg_score_aggregated"/>
                          </b-col>
                          <b-col cols="6">
                            <CardContentEsg title="Comparaison avec votre titre actuel" :esg_score="item.security.esg_score_aggregated"/>
                          </b-col>
                        </b-row>
                        <b-button class="right"  v-on:click="addAlternativeESG(item,o)">Valider mon nouveau titre</b-button>
                    </div>
                  </div>
                </div>
              </b-tab>
              <b-tab v-else title="Investissements plus verts">
                <b-col class="collapseBg">
                  <CardContentEmpty title="Pas d'alternatives ESG" />
                </b-col>
              </b-tab>
            </b-tabs>
          </b-row>
          <b-row>
            <div class="cardItemEndBtn p-2">
              <b-button class="left" v-on:click="addSecurity(item)">Conserver le même titre</b-button>
            </div>
          </b-row>
        </b-collapse>
      </b-row>
    </div>
</template>
<script>
import CardCollapse from "./CardCollapse.vue";
import CardContent from "./CardContent.vue";
import CardContentEmpty from "./CardContentEmpty.vue";
import CardContentEsg from "./CardCollaspeEsg.vue";
import CardContentCombined from "./CardCollaspeCombined.vue";
import CardSelectTitre from "./CardSelectTitre.vue";
export default {
  components: { CardCollapse, CardContent, CardSelectTitre, CardContentEsg,CardContentCombined,CardContentEmpty  },
  props: ["item", "countSecuritiesLeft", "addSecurity", "addAlternative", "addAlternativeESG"],
  data() {
    return {
      collapsed: false,
      perPage: 1,
      currentPage: 1,
      rows: 1,
    };
  },
  mounted() {
    this.$root.$on("bv::collapse::state", (id, collapsed) => {
      console.log(id);
      if (id === "collapse-" + this.uid) {
        this.collapsed = collapsed;
      }
    });
  },
  methods: {
    isSecurityShown(item)
    {
      if((item.alternatives.length > 0 || item.alternatives_ESG.length > 0) && item.has_traded == 0)
      {
        return true;
      }
      else
      {
        if(item.has_traded == 0)
        {
          this.addSecurity(item);
        }
        return false;
      }
    },
    total_savings(savings) {
      var all_savings = savings * 25;
      return (Math.round(all_savings * 100) / 100).toFixed(2) + " €";
    }
  }
};
</script>
<style lang="scss">
@import "./resources/sass/_variables.scss";
#CardItemsContainer {
  background: #242527 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 20px;
  opacity: 1;

  .pagination_cardItem {
    justify-content: space-between;
    height: 50px;
    background: #121212;
    border-radius: 33px;
    align-items: center;
    width: 100%;

    .page-link {
      margin: 5px;
      background-color: transparent;
      border: none;
    }

    .page-item.active .page-link {
      font-weight: bold;
      background-color: #242527;
      border-radius: 33px;
      color: $vstr_grey_color !important;
    }

    li {
      button {
        border: none;
        color: $lt_grey_color;

        &:hover {
          background-color: transparent;
        }
      }
    }
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.7s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    transition: opacity 0s;
    opacity: 0;
  }

  .collapsed > div > .toggleIconContainer > .when-opened,
  :not(.collapsed) > div > .toggleIconContainer > .when-closed {
    display: none;
  }

  .title {
    text-align: left;
    font: normal normal bold $mf_ft_size_title Segoe UI;
    letter-spacing: 0px;
    color: $purple_color;
    opacity: 1;
  }
  .subtitle {
    text-align: left;
    font: italic normal bold $mf_ft_size_text Segoe UI;
    letter-spacing: 0px;
    color: #ffffff;

    .number {
      text-align: left;
      font: italic normal bold $mf_ft_size_text Segoe UI;
      letter-spacing: 0px;
      color: $purple_color;
    }
  }

  .toggleItem {
    width: 100%;
    padding: 15px;
    &:hover {
      border-radius: 20px;
      cursor: pointer;
      background: #121212;
    }

    .titleAndIconContainer {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .toggleArrow {
      color: $purple_color;
      opacity: 1;
    }
    .partNb {
      text-align: right;
      font: italic normal bold $mf_ft_size_text Segoe UI;
      letter-spacing: 0px;
      color: #ffffff;
      opacity: 1;
      margin-bottom: 20px;
    }
    .toggleContentContainer {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .frais {
        text-align: left;
        font: italic normal bold $mf_ft_size_text Segoe UI;
        letter-spacing: 0px;
        color: $purple_color;
        opacity: 1;
      }
      .toggleContent {
        text-align: left;
        font: italic normal bold $mf_ft_size_text Segoe UI;
        letter-spacing: 0px;
        color: #ffffff;
        span {
          text-align: left;
          font: italic normal bold $mf_ft_size_text Segoe UI;
          letter-spacing: 0px;
          color: $purple_color;
        }
      }
    }
  }

  .collapseContainer {
    .cardItemEndBtn {
      $btnSize: 35%;
      display: flex;
      justify-content: space-between;
      width: 100%;
      .left {
        background: #121212 0% 0% no-repeat padding-box;
        box-shadow: 0px 3px 6px #00000029;
        border-radius: 41px;
        opacity: 1;
        border: none;
        padding: 15px;
        width: $btnSize;
      }
      .right {
        background: $purple_color 0% 0% no-repeat padding-box;
        box-shadow: 0px 3px 6px #00000029;
        border-radius: 41px;
        padding: 15px;
        width: $btnSize;
        opacity: 1;
      }
    }
    .collapseBg {
      background: #121212 0% 0% no-repeat padding-box;
      border-radius: 20px;
      opacity: 1;
      padding: 30px;
    }
    .nav-item {
      background: #121212 0% 0% no-repeat padding-box;
      border-radius: 20px;
      opacity: 1;
      text-align: center;
      font: normal normal normal $mf_ft_size_text Segoe UI;
      letter-spacing: 0px;
      color: $mf_ft_color_white;
      height: 50px;
      margin: 15px;
      width: 28%;
      a {
        color: white;
        height: 100%;
        width: 100%;
        font: normal normal normal $mf_ft_size_text Segoe UI;
        display: flex;
        align-items: center;
        justify-content: center;
        &:hover {
          border: none;
        }
        &:focus {
          border: none;
        }
      }
    }
    .nav-tabs .nav-link.active,
    .nav-tabs .nav-item.show .nav-link {
      border-radius: 20px;
      color: $mf_ft_color_white;
      background-color: $purple_color;
      border: none;
    }

    .nav-tabs {
      border-bottom: none;
    }
    .title {
      text-align: left;
      font: normal normal bold $mf_ft_size_title Segoe UI;
      letter-spacing: 0px;
      color: $purple_color;
      opacity: 1;
    }
    .contentContainer {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;

      .content {
        text-align: left;
        font: normal normal normal $mf_ft_size_text Segoe UI;
        letter-spacing: 0px;
        color: $mf_ft_color_white;
        padding: 15px;
      }
    }
  }
}
</style>
